import React, { useEffect } from "react";
import Terms from "./Terms";

const TermsPage = () => {
  useEffect(() => {
    const section = document.getElementById("terms");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return <Terms />;
};

export default TermsPage;
